// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_xyS9iu","footerWrapper":"ob_FhX6uZ","footerWrapper_withoutNavigation":"ob_oM5rQ0","root_isHomePage":"ob_HdOS6j","leftBoxIcon":"ob_Mgow6L"};